import { Controller, useFormContext } from "react-hook-form";
import { Input, Textarea, Select } from "rizzui";
import cn from "@/utils/class-names";
import FormGroup from "@/app/shared/form-group";
import FileInput from "./file-input";
import { Category } from "@/types";

interface FormOrderInfoProps {
    categories: Category[];
    className?: string;
}

export default function FormOrderInfo({
    categories,
    className,
}: FormOrderInfoProps) {
    const {
        register,
        control,
        formState: { errors },
        setValue,
    } = useFormContext();

    return (
        <FormGroup
            title="Order Details"
            description="Enter the order information"
            className={cn(className)}
        >
            <Input
                label="Product Name"
                labelClassName="font-medium text-gray-900"
                placeholder="Name"
                {...register("product.name")}
                error={
                    errors.product
                        ? (errors.product["name"]?.message as string)
                        : undefined
                }
            />

            <Controller
                name="product.categoryId"
                control={control}
                render={({ field }) => (
                    <Select
                        label="Product Category"
                        labelClassName="font-medium text-gray-900"
                        placeholder="Select Category"
                        options={categories.map((c) => ({
                            label: c.name,
                            value: c.id,
                        }))}
                        {...field}
                        error={
                            errors.product
                                ? (errors.product["categoryId"]
                                      ?.message as string)
                                : undefined
                        }
                    />
                )}
            />
            
            <Input
                label="Product Supplier"
                labelClassName="font-medium text-gray-900"
                placeholder="Supplier"
                {...register("product.supplier")}
                error={
                    errors.product
                        ? (errors.product["supplier"]?.message as string)
                        : undefined
                }
            />
            <Input
                label="Product Quantity"
                labelClassName="font-medium text-gray-900"
                type="number"
                placeholder="Quantity"
                {...register("quantity", {
                    setValueAs: (value) => parseInt(value, 10),
                })}
                error={
                    errors.quantity
                        ? (errors.quantity.message as string)
                        : undefined
                }
            />
            <Input
                label="Shipping Address"
                labelClassName="font-medium text-gray-900"
                placeholder="Shipping Address"
                {...register("shippingAddress")}
                error={
                    errors.shippingAddress
                        ? (errors.shippingAddress.message as string)
                        : undefined
                }
            />
            <Textarea
                label="Description"
                labelClassName="font-medium text-gray-900"
                rows={5}
                placeholder="Description"
                {...register("product.description")}
                error={
                    errors.product
                        ? (errors.product["description"]?.message as string)
                        : undefined
                }
            />
            <FileInput
                label="Image"
                onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            // @ts-ignore
                            setValue("product.imagePath", e.target.result);
                        };
                        reader.readAsDataURL(file);
                    }
                }}
            />
        </FormGroup>
    );
}
